/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import {
  Row, Tabs,
} from 'antd';
import { BellOutlined, FileTextOutlined, MenuUnfoldOutlined } from '@ant-design/icons';
import { getModelPermission } from 'utils/permission';
import ConfiguradorNombramientos from './ConfiguracionNombramientos';
import ConfiguradorNombramientosFormato, { ConfiguradorNombramientosFormatoPermission } from './ConfiguradorNombramientosFormato';
import ConfiguradorNombramientoUsuarioNotificar, { configuradorNombramientoUsuarioNotificarPermission } from './ConfiguradorNombramientoUsuarioNotificar';

function ConfiguradorNombramientosMenu({ permission }) {
  const firstTab = 'avisoDeRenovacion';
  const secondTab = 'Formato';
  const thirdTab = 'usuariosNotificar';
  const [currentParentTabKey, setCurrentParentTabKey] = useState(firstTab);
  const tabItems = [
    {
      key: firstTab,
      label: (
        <span>
          <MenuUnfoldOutlined />
          {' '}
          Aviso de Renovación
        </span>
      ),
      children: (
        <ConfiguradorNombramientos
          permission={permission}
        />
      ),
      forceRender: true,
    },
    {
      key: secondTab,
      label: (
        <span>
          <FileTextOutlined />
          {' '}
          Formato
        </span>
      ),
      children: (
        <ConfiguradorNombramientosFormato
          permission={getModelPermission(
            ConfiguradorNombramientosFormatoPermission.permissionModel,
          )}
        />
      ),
      forceRender: true,
    },
    {
      key: thirdTab,
      label: (
        <span>
          <BellOutlined />
          {' '}
          Usuarios a Notificar Renovación
        </span>
      ),
      children: (
        <ConfiguradorNombramientoUsuarioNotificar
          permission={getModelPermission(
            configuradorNombramientoUsuarioNotificarPermission.permissionModel,
          )}
        />
      ),
      forceRender: true,
    },
  ];

  return (
    <Row className="container">

      <Tabs
        type="card"
        activeKey={currentParentTabKey || firstTab}
        onChange={setCurrentParentTabKey}
        items={tabItems}
      />
    </Row>
  );
}

export default ConfiguradorNombramientosMenu;
